<template>
  <span v-text="timeShow" />
</template>

<script>
import UsesRole from "../mixins/UsesRole";
import DisplaysTime from "../mixins/DisplaysTime";

export default {
  name: "UtcTime",
  mixins: [UsesRole, DisplaysTime],
  computed: {
    timeShow() {
      return this.displayAndFormatTime(this.time, this.timezone, this.format, this.isHighLevelOrManager);
    }
  },
  props: {
    role: {
      type: String,
      required: false,
      default: '',
    },
    time: {
      required: false,
      default: '',
    },
    timezone: {
      type: String,
      default: null,
    },
    format: {
      type: String,
      default: () => 'MM/DD/YYYY h:mm A z',
    },
  },
}
</script>

<style scoped>

</style>